export function statusLabel(licence) {
  if (licence.revoked_at != null) {
    return "Révoquée";
  }
  if (licence.activated_at != null) {
    return "Activée";
  }
  return "Inactive";
}
